/* eslint-disable @typescript-eslint/no-unused-vars */
import { Datagrid, TextInput, TextField, useTranslate } from 'react-admin'
import UploadIcon from '@mui/icons-material/Upload'
import { ListBase } from '../../components/base'
import { COMMON_FIELDS, PRODUCTS_COMMON_FIELDS } from '../../providers/localization/constant'
import { ImportButton } from '../../components/buttons/ImportButton'

const CarsBrakeList = (): JSX.Element => {
  const translate = useTranslate()
  const carListFilters = [
    <TextInput key={0} source='prod_code' label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)} />,
    <TextInput key={1} source='brand' label={translate(`${PRODUCTS_COMMON_FIELDS}.brand.label`)} />,
    <TextInput key={2} source='model' label={translate(`${PRODUCTS_COMMON_FIELDS}.model.label`)} />,
    <TextInput key={3} source='sub_model' label={translate(`${PRODUCTS_COMMON_FIELDS}.sub_model.label`)} />,
    <TextInput key={4} source='year' label={translate(`${COMMON_FIELDS}.year`)} />,
  ]

  return (
    <ListBase
      listAction={{
        hasCreate: false,
        menuItems: [
          {
            label: `${PRODUCTS_COMMON_FIELDS}.import.title`,
            button: (
              <ImportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.import.title`)}
                variant='contained'
                // ** todo import car **
                to={'/import-master-data/cars/brake'}
                key={19}
                icon={<UploadIcon />}
              />
            ),
            visible: true,
          },
        ],
      }}
      perPage={50}
      filters={carListFilters}
      sort={{ field: 'brand', order: 'asc' }}
    >
      <Datagrid rowClick={null} bulkActionButtons={null}>
        <TextField source='prod_code' label={`${PRODUCTS_COMMON_FIELDS}.prod_code.label`} />
        <TextField source='brand' label={`${PRODUCTS_COMMON_FIELDS}.brand.label`} />
        <TextField source='model' label={`${PRODUCTS_COMMON_FIELDS}.model.label`} />
        <TextField source='sub_model' label={`${PRODUCTS_COMMON_FIELDS}.sub_model.label`} />
        <TextField source='year' label={`${COMMON_FIELDS}.year`} />
      </Datagrid>
    </ListBase>
  )
}

export default CarsBrakeList
